import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../common/utils';
import { AddressOptionsFacade } from './address-options.facade';

@Injectable({
  providedIn: 'root',
})
export class AddressOptionsGuard  {
  constructor(private addressOptionsFacade: AddressOptionsFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.addressOptionsFacade);
  }
}
